import { format } from "date-fns";
import { BACKGROUND_DATA_LIST, CATEGORIES_OPTIONS, DAYS } from "../../../contracts";

import en from "../../../i18n/json/en.json";
import es from "../../../i18n/json/es.json";
import eslat from "../../../i18n/json/eslat.json";
import ca from "../../../i18n/json/ca.json";
import fr from "../../../i18n/json/fr.json";
import ga from "../../../i18n/json/ga.json";
import it from "../../../i18n/json/it.json";
import pt from "../../../i18n/json/pt.json";
import { getUserLanguage } from "@utils/lang";

type Dictionary = Record<string, string>;

const DICTS: Record<string, Dictionary> = {
    en: en as Dictionary,
    es: es as Dictionary,
    eslat: eslat as Dictionary,
    ca: ca as Dictionary,
    fr: fr as Dictionary,
    ga: ga as Dictionary,
    it: it as Dictionary,
    pt: pt as Dictionary,
};

function coerceLang(lang: unknown): string {
    if (typeof lang !== "string") return "es";
    const normalized = lang.trim().toLowerCase();
    if (!normalized) return "es";
    // allow "es-ES" etc
    return normalized;
}

function getDictForLang(langRaw: unknown): Dictionary {
    const lang = coerceLang(langRaw);
    const direct = DICTS[lang];
    if (direct) return direct;

    const base = lang.split("-")[0];
    if (base && DICTS[base]) return DICTS[base];

    return DICTS.es;
}

function interpolate(template: string, params: Record<string, unknown>) {
    if (!template) return template;

    // Replace {key} and ${key} (word-only keys to avoid touching expressions)
    return template
        .replace(/\{(\w+)\}/g, (_, k: string) => {
            const v = params[k];
            return v === undefined || v === null ? `{${k}}` : String(v);
        })
        .replace(/\$\{(\w+)\}/g, (_, k: string) => {
            const v = params[k];
            return v === undefined || v === null ? `\${${k}}` : String(v);
        });
}


export function translate(key: string, defaultValue = '', params = {}) {
    try {
        const lang = getUserLanguage();
        const dict = getDictForLang(lang);

        const raw = dict?.[key];
        const value =
            typeof raw === "string" && raw.trim() !== ""
                ? raw
                : defaultValue !== ""
                    ? defaultValue
                    : key;

        return interpolate(value, params as Record<string, unknown>);
    } catch (e) {
        console.error("Translation error:", e, key, defaultValue, params);
        return defaultValue || key;
    }
}

export function safeJSONParser(jsonData: any) {
    try {
        // console.log("🔍 JSON tipo:", typeof jsonData);
        if (typeof jsonData === "object" && jsonData !== null) {
            return jsonData;
        }
        if (typeof jsonData === "string") {
            // console.log("🔍 JSON string:", jsonData);
            return JSON.parse(jsonData);
        }
        return null;
    } catch {
        return null;
    }
}

export function safeJSONStringify(data: any) {
    try {
        return JSON.stringify(data);
    } catch {
        return null;
    }
}

export const isUrl = (str: string) =>
    /^https?:\/\/[^\s]+$/.test(str);

export async function insertBackgroundIntoSteps(wizard: any, userBackground: any) {
    try {
        const formatedSteps = formatSettingsBackground(userBackground);
        // console.log('steps: ', JSON.stringify(formatedSteps));
        wizard.steps?.forEach((el: any, index: any) => {
            el.options?.forEach((option: any, indexOption: any) => {
                // console.log('option.storeId: ', option.storeId, formatedSteps[option.storeId], formatedSteps[option.storeId]?.checkedValue);
                if (formatedSteps[option.storeId] || String(formatedSteps[option.storeId]) === '0') {
                    if (formatedSteps[option.storeId].checkedValue) {
                        if (wizard.steps[index].options[indexOption].storeId === 'categoriesToAvoid') {
                            wizard.steps[index].options[indexOption].checkedValue = userBackground.foodCategoriesToAvoid && userBackground.foodCategoriesToAvoid.length > 0 ? userBackground.foodCategoriesToAvoid[0] : []
                        }
                        if (wizard.steps[index].options[indexOption].storeId === 'foodCategoriesToAvoid') {
                            wizard.steps[index].options[indexOption].checkedValue = [];
                            if (!formatedSteps[option.storeId].checkedValue.includes('31') && !formatedSteps['ingredientsToAvoid'].checkedValue.includes('ternera'))
                                wizard.steps[index].options[indexOption].checkedValue.push('meat');
                            if (!formatedSteps[option.storeId].checkedValue.includes('32') && !formatedSteps['ingredientsToAvoid'].checkedValue.includes('pollo'))
                                wizard.steps[index].options[indexOption].checkedValue.push('chicken');
                            if (!formatedSteps[option.storeId].checkedValue.includes('40') && !formatedSteps['ingredientsToAvoid'].checkedValue.includes('cerdo'))
                                wizard.steps[index].options[indexOption].checkedValue.push('pork');
                            if (!formatedSteps[option.storeId].checkedValue.includes('10') && !formatedSteps['ingredientsToAvoid'].checkedValue.includes('huevo'))
                                wizard.steps[index].options[indexOption].checkedValue.push('eggs');
                            if (!formatedSteps[option.storeId].checkedValue.includes('11'))
                                wizard.steps[index].options[indexOption].checkedValue.push('fish');
                            if (!formatedSteps[option.storeId].checkedValue.includes('28'))
                                wizard.steps[index].options[indexOption].checkedValue.push('legumes');
                            if (!formatedSteps[option.storeId].checkedValue.includes('14'))
                                wizard.steps[index].options[indexOption].checkedValue.push('milk');
                        }
                        else {
                            wizard.steps[index].options[indexOption].checkedValue = formatedSteps[option.storeId].checkedValue;
                            // console.log('3**********------>>>>>>>>>', formatedSteps[option.storeId].checkedValue, formatedSteps[option.storeId], wizard.steps[index].options[indexOption].storeId, wizard.steps[index].options[indexOption].checkedValue, wizard['storageData'][option.storeId]);
                            wizard['storageData'][option.storeId] = formatedSteps[option.storeId].checkedValue;
                        }
                        // console.log('1**********------>>>>>>>>>', formatedSteps[option.storeId].checkedValue, formatedSteps[option.storeId], wizard.steps[index].options[indexOption].storeId, wizard.steps[index].options[indexOption].checkedValue);
                    } else {
                        // console.log('2**********------>>>>>>>>>', formatedSteps[option.storeId].checkedValue, formatedSteps[option.storeId], wizard.steps[index].options[indexOption].storeId, wizard.steps[index].options[indexOption].checkedValue);
                        wizard.steps[index].options[indexOption].checkedValue = formatedSteps[option.storeId];
                        // console.log('4**********------>>>>>>>>>', formatedSteps[option.storeId], wizard.steps[index].options[indexOption].storeId, wizard.steps[index].options[indexOption].checkedValue, wizard['storageData'][option.storeId]);
                        wizard.storageData[option.storeId] = formatedSteps[option.storeId];
                    }
                }
            })
        });
        // console.log('--->>>>>>>>>>>>>>>>> wizard: ', JSON.stringify(wizard));
        return wizard;
    } catch (error) {
        console.log('Error insertBackgroundIntoSteps: ', error);
        return wizard;
    }
};

export function formatSettingsBackground(values: any) {
    const allergens = values.allergens && values.allergens[0] ? values.allergens[0] : [];
    const diseases = values.diseases && values.diseases[0] ? values.diseases[0] : [];
    allergens.forEach((item: any, i: any) => {
        allergens[i] = Number(item);
    });
    diseases.forEach((item: any, i: any) => {
        diseases[i] = Number(item);
    });
    const workouts = values.workoutSchedule ? Object.assign(values.workoutSchedule) : [];

    const exMon = workouts.filter(el => el[0] === 'monday'); exMon.forEach((item: any, i: any) => { workouts[i] = item.shift(); });
    const exTue = workouts.filter(el => el[0] === 'tuesday'); exTue.forEach((item: any, i: any) => { workouts[i] = item.shift(); });
    const exWed = workouts.filter(el => el[0] === 'wednesday'); exWed.forEach((item: any, i: any) => { workouts[i] = item.shift(); });
    const exThu = workouts.filter(el => el[0] === 'thursday'); exThu.forEach((item: any, i: any) => { workouts[i] = item.shift(); });
    const exFri = workouts.filter(el => el[0] === 'friday'); exFri.forEach((item: any, i: any) => { workouts[i] = item.shift(); });
    const exSat = workouts.filter(el => el[0] === 'saturday'); exSat.forEach((item: any, i: any) => { workouts[i] = item.shift(); });
    const exSun = workouts.filter(el => el[0] === 'sunday'); exSun.forEach((item: any, i: any) => { workouts[i] = item.shift(); });

    const presetRecipes = values.presetRecipeSchedule ? Object.assign(values.presetRecipeSchedule) : [];
    const recMon = presetRecipes.filter(el => el[0] === 'monday'); recMon.forEach((item: any, i: any) => { presetRecipes[i] = item.shift(); });
    const recTue = presetRecipes.filter(el => el[0] === 'tuesday'); recTue.forEach((item: any, i: any) => { presetRecipes[i] = item.shift(); });
    const recWed = presetRecipes.filter(el => el[0] === 'wednesday'); recWed.forEach((item: any, i: any) => { presetRecipes[i] = item.shift(); });
    const recThu = presetRecipes.filter(el => el[0] === 'thursday'); recThu.forEach((item: any, i: any) => { presetRecipes[i] = item.shift(); });
    const recFri = presetRecipes.filter(el => el[0] === 'friday'); recFri.forEach((item: any, i: any) => { presetRecipes[i] = item.shift(); });
    const recSat = presetRecipes.filter(el => el[0] === 'saturday'); recSat.forEach((item: any, i: any) => { presetRecipes[i] = item.shift(); });
    const recSun = presetRecipes.filter(el => el[0] === 'sunday'); recSun.forEach((item: any, i: any) => { presetRecipes[i] = item.shift(); });

    let mealSchedule = values.mealSchedule ? values.mealSchedule : [
        ['08:00', translate('LANG_BREAKFAST')],
        ['12:00', translate('LANG_MORNING_SNACK')],
        ['14:00', translate('LANG_LUNCH')],
        ['17:00', translate('LANG_SNACK')],
        ['20:00', translate('LANG_DINNER')],
    ];
    mealSchedule = sortMealHours(mealSchedule);

    return {
        ...values,
        measures: values.measures ? Number(values.measures) : 0,
        breastfeeding: values.breastfeeding === 'true',
        menopause: values.menopause === 'true',
        pregnant: values.pregnant === 'true',
        diet: values.dietType,
        preparationTime: getFormatPreparationTime(values.preparationTime),
        foodCategoriesToAvoid: {
            type: 'list', listType: 'select', storeId: 'foodCategoriesToAvoid', label: '', buttonText: translate('LANG_ADD_CATEGORY'),
            options: CATEGORIES_OPTIONS, defaultValue: '',
            checkedValue: values.foodCategoriesToAvoid?.[0] || []
        },
        categoriesToAvoid: {
            type: 'list', listType: 'select', storeId: 'categoriesToAvoid', label: '', buttonText: translate('LANG_ADD_CATEGORY'),
            options: CATEGORIES_OPTIONS, defaultValue: '',
            checkedValue: values.foodCategoriesToAvoid?.[0] || []
        },
        ingredientsToAvoid: {
            type: 'list', listType: 'input', storeId: 'ingredientsToAvoid', label: '',
            placeholder: translate('LANG_INGREDIENTS_AVOID_LABEL'), buttonText: translate('LANG_INGREDIENTS_AVOID_BUTTON'),
            inputType: 'text', defaultValue: '', checkedValue: values.ingredientsToAvoid?.[0] || []
        },
        weight: Number(values.weight), height: Number(values.height),
        allergens, diseases,
        birthdate: values.birthdate ? formatDateUtil(new Date(values.birthdate), 'yyyy-MM-dd') : '1985-01-01',
        ageNum: values.ageNum ? Number(values.ageNum) : (values.birthdate ? Number(formatDateUtil(new Date(), 'yyyy')) - Number(formatDateUtil(new Date(values.birthdate), 'yyyy')) : 35),
        startingDate: values.startingDate ? formatDateUtil(new Date(values.startingDate), 'yyyy-MM-dd') : formatDateUtil(new Date(), 'yyyy-MM-dd'),
        mealHours: {
            type: 'list', listType: 'foodRange', storeId: 'mealHours',
            label: translate('LANG_MEAL_HOURS_LABEL'),
            buttonText: translate('LANG_MEAL_HOURS_ADD'),
            placeholder: translate('LANG_MEAL_HOURS_PLACEHOLDER'),
            inputType: 'time', defaultValue: '12:00', checkedValue: mealSchedule
        },
        ...generateDailyFields('exercice', 'hourRange', workouts, translate),
        ...generateDailyFields('recipes', 'presetRecipes', presetRecipes, translate)
    }
}

function generateDailyFields(prefix: string, type: string, data: any[], translate: Function) {
    const days = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];
    const fullDays = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];
    const result: any = {};

    days.forEach((day, i) => {
        const el = data.filter((d: any) => d[0] === fullDays[i].toLowerCase());
        el.forEach((item: any, j: any) => {
            data[j] = item.shift();
        });
        result[`${prefix}${day}`] = {
            type: 'list', listType: type,
            storeId: `${prefix}${day}`,
            label: type === 'hourRange' ? translate('LANG_TRAINING_LABEL') : translate('LANG_RECIPES_LABEL'),
            buttonText: translate(`LANG_${fullDays[i]}`),
            placeholder: type === 'hourRange' ? translate('LANG_TRAINING_PLACEHOLDER') : translate('LANG_RECIPES_PLACEHOLDER'),
            inputType: type === 'hourRange' ? 'time' : 'text',
            defaultValue: '',
            checkedValue: el
        }
    });

    return result;
}

export function sortMealHours(mealHours: any) {
    return mealHours.sort((a: any, b: any) => a[0].localeCompare(b[0]));
}

export function shuffleArray(array: any) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
}

function getFormatPreparationTime(value: any) {
    // console.log(value);
    if (Number(value) <= 15)
        return 'lessthan15';
    if (Number(value) > 15 && Number(value) <= 30)
        return 'about30';
    if (Number(value) > 30)
        return 'morethan30';
    return 'morethan30'
}
const DATE_FORMAT = 'dd/MM/yyyy';

export function formatDateUtil(day: any, dateFormat: any = DATE_FORMAT, locale = null) {
    if (locale) {
        return format(new Date(day), dateFormat, { locale });
    } else {
        return format(new Date(day), dateFormat);
    }
}

// New Format functions for different data structures

export function formatInOneRow(data: any) {
    return [data];
}

export function formatGetFirstRow(data: any) {
    return data ? data[0] : '';
}

export function formatContentArray(array: any) {
    if (!Array.isArray(array)) {
        return [];
    }
    return array.map((item: any) => {
        return [item];
    });
}

function formatGetWorkoutSchedule(workoutSchedule: any) {
    const result: any = {};
    DAYS.forEach((day) => {
        result[day] = workoutSchedule?.filter((el: any) => el[0] === day).map((el: any) => {
            return [el[1], el[2], el[3]];
        });
    });

    return result;
}

function formatUpdateWorkoutSchedule(background: any) {
    const workoutSchedule: any = [];
    DAYS.forEach((day) => {
        if (background[day] && background[day].length > 0) {
            background[day].forEach((el: any) => {
                workoutSchedule.push([day, el[0], el[1], el[2]])
            });
        }
    });

    return workoutSchedule;
}


export function formatBackground(background: any, type = "get") {
    Object.keys(background).forEach((key) => {
        if (BACKGROUND_DATA_LIST.includes(key)) {
            if (type === "update") {
                key === 'workoutSchedule'
                    ? background["workoutSchedule"] = formatUpdateWorkoutSchedule(background)
                    : background[key] = formatInOneRow(background[key]);

            } else {
                key === 'workoutSchedule'
                    ? background = { ...background, ...formatGetWorkoutSchedule(background[key]) }
                    : background[key] = formatGetFirstRow(background[key]);

            }
        }
    });

    return background;
}

export function deepClone(obj: any) {
    return JSON.parse(JSON.stringify(obj));
}

export function parseMacroString(value: string) {
    const regex = /(\d+)%\s*C\s*\/\s*(\d+)%\s*P\s*\/\s*(\d+)%\s*G/;
    const match = value.match(regex);

    if (match) {
        const [, carb, prot, fat] = match;
        return {
            carb: Number(carb),
            prot: Number(prot),
            fat: Number(fat)
        };
    } else {
        return {
            carb: 0,
            prot: 0,
            fat: 0
        };
    }
}

export function formatSmartNumber(value: any) {
    const num = Number(value);
    if (isNaN(num)) return "";

    // Si es 0 exacto, devuelve "0"
    if (num === 0) return "0";

    // Si es entero, devuelve sin decimales
    if (Number.isInteger(num)) return num.toString();

    // Si tiene decimales, muestra con 1 decimal
    return num.toFixed(1);
}

export function translateIngredientUnit(unit: string) {
    const unitsMap: { [key: string]: string } = {
        'units': translate('UNITS', 'unidades'),
        'grams': translate('GRAMS', 'gramos'),
        'handful': translate('HANDFUL', 'puñado'),
        'pinch': translate('PINCH', 'pizca'),
        'spoonful': translate('SPOONFUL', 'cucharada'),
        'teaspoondul': translate('TEASPOONFUL', 'cucharadita'),
        'cup': translate('CUP', 'taza'),
        'glass': translate('GLASS', 'vaso'),
        'milliliters': translate('MILLILITERS', 'mililitros'),
        'can': translate('CAN', 'lata pequeña'),
        'trickle': translate('TRICKLE', 'chorrito'),
        'leaf': translate('LEAF', 'hoja'),
    };
    return unitsMap[unit] || unit;
}